import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoriesService } from 'app/modules/categories/categories.service';
import { PageService } from 'app/services/page-service';

@Component({
  selector: 'app-ordered-products',
  templateUrl: './ordered-products.component.html',
  styles: [
  ]
})
export class OrderedProductsComponent implements OnInit {
  @Input() content: any;
  subName = '';
  subDescription = '';
  subCategories = [];
  editIndex = 0;
  action = '';
  action2 = '';
  subCategoryArray = [];

  constructor(
    public dialogRef: NgbActiveModal,
    public service: PageService,
    public catService: CategoriesService
  ) { }

  ngOnInit() {
    console.log(this.content);
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
